import {Component, Input, OnInit} from "@angular/core";

@Component({
    selector: 'shed-system',
    templateUrl: './shed-system.component.html',
    styleUrls: ['./shed-system.component.scss']
})
export class ShedSystemComponent implements OnInit {

    @Input() heading: string = 'Shed System';
    @Input() slogan: string = 'Load-shedding System, Small Homes or Workshops';
    @Input() headerCssClass: string = 'p-3';

    @Input() showImage: boolean = true;
    @Input() showHeading: boolean = false;
    @Input() showEmpty: boolean = true;

    constructor() {
    }

    ngOnInit(): void {
    }
}
